module.exports = __webpack_public_path__ + "img/2.cebb2534.png";